import React from "react";
import { Button, IconButton } from "@mui/material";
import styles from "../QuoteMultipleDestinationsPanel.module.css";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import { WarningTriangleIcon, XIcon } from "../../../icons";
import { updateInboundModes } from "./multiLocationQuoteUtils";
import { useNitroStore } from "../../../store/Store";

const TurnOffModePanel: React.FC = () => {
  const [
    setDisplayTurnOffModePanel,
    setDisplayInboundModeTogglePanel,
    destination,
    modeToTurnOff,
    setExpandedDestination,
  ] = useNitroCAStore((state) => [
    state.setDisplayTurnOffModePanel,
    state.setDisplayInboundModeTogglePanel,
    state.destinationToTroubleshoot,
    state.modeToTurnOff,
    state.setExpandedDestination,
  ]);
  const [setMultiLocationDestinations] = useNitroStore((state) => [
    state.setMultiLocationDestinations,
  ]);
  const triggerRefetchQuotes = useNitroCAStore(
    (state) => state.triggerRefetchQuotes,
  );

  const close = () => {
    setDisplayTurnOffModePanel(false);
    setDisplayInboundModeTogglePanel(false);
  };

  return (
    <div className={styles.turnOffModePanel}>
      <div style={{ pointerEvents: "auto" }}>
        <div className={styles.turnOffModeContainer}>
          <div className={styles.turnOffModeHeader}>
            <div className={styles.warningTurnOffModeIconContainer}>
              <div style={{ marginTop: 4, marginLeft: 1 }}>
                <WarningTriangleIcon stroke="#1D4ED8" size={18} />
              </div>
            </div>
            {/* TITLE */}
            <div className={styles.turnOffModeTitle}>
              Turn Off Inbound Mode?
            </div>

            {/* CLOSE BUTTON */}
            <div style={{ marginLeft: "auto" }}>
              <IconButton
                size="small"
                onClick={close}
                data-testid="TurnOffModePanel-x-button"
              >
                <XIcon />
              </IconButton>
            </div>
          </div>

          {/* MAIN MESSAGE */}
          <div className={styles.turnOffModeText}>
            <span style={{ color: "#1d4ed8" }}>Important: </span>
            <span style={{ color: "#45556c" }}>
              This will affect everyone viewing this location and is not
              intended as a filter for the table.
            </span>
          </div>

          {/* BUTTONS */}
          <div className={styles.addInboundRailButtonContainer}>
            <Button
              data-testid="TurnOffModePanel-cancel-button"
              sx={{
                borderRadius: "8.5px",
                border: "1.25px solid rgba(0, 0, 0, 0.08)",
                color: "#0a0a0a",
                backgroundColor: "#fff",
                fontFamily: "inter",
                fontWeight: 400,
                fontSize: "14px",
                padding: "7px 14px",
              }}
              onClick={close}
            >
              Cancel
            </Button>
            <Button
              sx={{
                borderRadius: "8.5px",
                background: "#1D4ED8",
                color: "#FFFFFF",
                fontFamily: "inter",
                fontWeight: 400,
                fontSize: "14px",
                padding: "7px 14px",
                "&:hover": {
                  backgroundColor: "secondary.main",
                },
                "&:disabled": {
                  backgroundColor: "#CAD5E2",
                  color: "#FFFFFF",
                },
              }}
              onClick={async () => {
                await updateInboundModes(destination, false, modeToTurnOff);
                close();
                // on successfully turning off mode, refetch multi-location data and open destination panel
                setMultiLocationDestinations([]);
                triggerRefetchQuotes();
                setExpandedDestination(
                  {
                    id: destination.id,
                    name: destination.name,
                  },
                  {
                    expandSurroundingLocations:
                      destination.isSurroundingLocation,
                  },
                );
              }}
              data-testid="TurnOffModePanel-turn-off-mode-button"
            >
              Turn Mode Off
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TurnOffModePanel;
